// Copyright (c) 2021 Deere & Company

import Chance from 'chance';

const chance = new Chance();

export const generateTemporaryObjectKey = () => chance.hash({length: 32});



// WEBPACK FOOTER //
// ./src/shared/services/generate-temporary-object-key.js